export default [
    {
      path: '/mng/rhino/download/index',
      name: 'profile',
      component: () => import('@/pages/mng/download/App.vue'),
      meta: {
        title: '下载中心',
      },
    },
  ];
